export enum ResolvedUserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  REMOVED = 'REMOVED'
}

/**
 * Display info for an arbitrary (possibly deleted/tombstoned or org-unlinked) user id, returned by
 * POST /api/users/resolve. Used to render historical assignees/watchers that the active-user
 * suggestions list cannot see. Never includes an email address.
 */
export interface ResolvedUser {
  id: string;
  display_name?: string;
  first_name?: string;
  last_name?: string;
  color?: string;
  disabled?: boolean;
  deleted?: boolean;
  status?: ResolvedUserStatus;
}
